import Businesses from 'routes/Businesses'

export default Businesses
